// extracted by mini-css-extract-plugin
export default {"sort_up":"header_sort_up__qvOxZ","sort_down":"header_sort_down__j4OIf"};